// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgEducationUnique24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_4564_301561)">
					<path
						d="M12.3633 19.3585H11.7331C11.463 19.3585 11.2379 19.1672 11.1704 18.8859C11.1366 18.7283 11.0128 18.6158 10.8778 18.6158H4.78933C4.58676 18.6158 4.4292 18.4582 4.4292 18.2556V6.47268C4.4292 6.27011 4.58676 6.11255 4.78933 6.11255H11.6993C12.262 6.11255 12.7234 6.60773 12.7234 7.21544V18.9984C12.7234 19.201 12.5659 19.3585 12.3633 19.3585ZM11.8569 18.627H12.0032V7.21544C12.0032 7.01287 11.8681 6.84406 11.6993 6.84406H5.16071V17.8955H10.889C11.3279 17.8955 11.7218 18.1994 11.8569 18.627Z"
						fill="#191919"
						stroke="#191919"
						strokeWidth={0.2}
						strokeMiterlimit={10}
					/>
					<path
						d="M10.1801 19.8875H3.47268C3.27011 19.8875 3.11255 19.73 3.11255 19.5274V7.73318C3.11255 7.5306 3.27011 7.37305 3.47268 7.37305C3.67525 7.37305 3.83281 7.5306 3.83281 7.73318V19.156H10.1688C10.3714 19.156 10.5289 19.3136 10.5289 19.5161C10.5289 19.7187 10.3714 19.8763 10.1688 19.8763L10.1801 19.8875Z"
						fill="#191919"
						stroke="#191919"
						strokeWidth={0.2}
						strokeMiterlimit={10}
					/>
					<path
						d="M12.9935 19.3585H12.3633C12.1607 19.3585 12.0032 19.201 12.0032 18.9984V7.21544C12.0032 6.60773 12.4646 6.11255 13.0273 6.11255H19.7797C19.9823 6.11255 20.1398 6.27011 20.1398 6.47268C20.1398 6.67525 19.9823 6.83281 19.7797 6.83281H13.0273C12.8697 6.83281 12.7234 7.00162 12.7234 7.20419V18.627H12.8697C13.016 18.1881 13.3987 17.8955 13.8376 17.8955H19.5659V15.7347C19.5659 15.5322 19.7234 15.3746 19.926 15.3746C20.1286 15.3746 20.2861 15.5322 20.2861 15.7347V18.2669C20.2861 18.4695 20.1286 18.627 19.926 18.627H13.8376C13.7025 18.627 13.59 18.7396 13.545 18.8971C13.4775 19.1672 13.2524 19.3698 12.9823 19.3698L12.9935 19.3585Z"
						fill="#191919"
						stroke="#191919"
						strokeWidth={0.2}
						strokeMiterlimit={10}
					/>
					<path
						d="M19.9373 9.6688C19.7347 9.6688 19.5771 9.51124 19.5771 9.30867V6.84404C19.3858 6.83278 19.2395 6.67523 19.2395 6.48391C19.2395 6.29259 19.3971 6.12378 19.5996 6.12378H19.9373C20.1398 6.12378 20.2974 6.28134 20.2974 6.48391V9.31992C20.2974 9.52249 20.1398 9.68005 19.9373 9.68005V9.6688Z"
						fill="#191919"
					/>
					<path
						d="M21.2539 8.46458C21.0514 8.46458 20.8938 8.30703 20.8938 8.10445V7.31667C20.8938 7.1141 21.0514 6.95654 21.2539 6.95654C21.4565 6.95654 21.6141 7.1141 21.6141 7.31667V8.10445C21.6141 8.30703 21.4565 8.46458 21.2539 8.46458Z"
						fill="#191919"
					/>
					<path
						d="M21.254 19.8874H14.5579C14.3553 19.8874 14.1978 19.7299 14.1978 19.5273C14.1978 19.3247 14.3553 19.1672 14.5579 19.1672H20.8939V14.7669C20.8939 14.5643 21.0515 14.4067 21.254 14.4067C21.4566 14.4067 21.6142 14.5643 21.6142 14.7669V19.5273C21.6142 19.7299 21.4566 19.8874 21.254 19.8874Z"
						fill="#191919"
						stroke="#191919"
						strokeWidth={0.2}
						strokeMiterlimit={10}
					/>
					<path
						d="M12.9823 9.55619H11.7556C11.5531 9.55619 11.3955 9.39864 11.3955 9.19607C11.3955 8.99349 11.5531 8.83594 11.7556 8.83594H12.9823C13.1849 8.83594 13.3425 8.99349 13.3425 9.19607C13.3425 9.39864 13.1849 9.55619 12.9823 9.55619Z"
						fill="#191919"
					/>
					<path
						d="M12.9823 10.6929H11.7556C11.5531 10.6929 11.3955 10.5354 11.3955 10.3328C11.3955 10.1302 11.5531 9.97266 11.7556 9.97266H12.9823C13.1849 9.97266 13.3425 10.1302 13.3425 10.3328C13.3425 10.5354 13.1849 10.6929 12.9823 10.6929Z"
						fill="#191919"
					/>
					<path
						d="M12.9823 11.8296H11.7556C11.5531 11.8296 11.3955 11.6721 11.3955 11.4695C11.3955 11.2669 11.5531 11.1094 11.7556 11.1094H12.9823C13.1849 11.1094 13.3425 11.2669 13.3425 11.4695C13.3425 11.6721 13.1849 11.8296 12.9823 11.8296Z"
						fill="#191919"
					/>
					<path
						d="M12.9823 12.9664H11.7556C11.5531 12.9664 11.3955 12.8088 11.3955 12.6062C11.3955 12.4036 11.5531 12.2461 11.7556 12.2461H12.9823C13.1849 12.2461 13.3425 12.4036 13.3425 12.6062C13.3425 12.8088 13.1849 12.9664 12.9823 12.9664Z"
						fill="#191919"
					/>
					<path
						d="M12.9823 14.0916H11.7556C11.5531 14.0916 11.3955 13.934 11.3955 13.7315C11.3955 13.5289 11.5531 13.3713 11.7556 13.3713H12.9823C13.1849 13.3713 13.3425 13.5289 13.3425 13.7315C13.3425 13.934 13.1849 14.0916 12.9823 14.0916Z"
						fill="#191919"
					/>
					<path
						d="M12.9823 15.2283H11.7556C11.5531 15.2283 11.3955 15.0708 11.3955 14.8682C11.3955 14.6656 11.5531 14.5081 11.7556 14.5081H12.9823C13.1849 14.5081 13.3425 14.6656 13.3425 14.8682C13.3425 15.0708 13.1849 15.2283 12.9823 15.2283Z"
						fill="#191919"
					/>
					<path
						d="M16.7073 14.3956L20.2973 10.4004L21.8954 11.9309L18.3729 16.1512L16.7073 14.3956Z"
						fill="#AD24C9"
					/>
					<path
						d="M12.9823 16.365H11.7556C11.5531 16.365 11.3955 16.2075 11.3955 16.0049C11.3955 15.8023 11.5531 15.6448 11.7556 15.6448H12.9823C13.1849 15.6448 13.3425 15.8023 13.3425 16.0049C13.3425 16.2075 13.1849 16.365 12.9823 16.365Z"
						fill="#191919"
					/>
					<path
						d="M12.9823 17.4903H11.7556C11.5531 17.4903 11.3955 17.3327 11.3955 17.1301C11.3955 16.9276 11.5531 16.77 11.7556 16.77H12.9823C13.1849 16.77 13.3425 16.9276 13.3425 17.1301C13.3425 17.3327 13.1849 17.4903 12.9823 17.4903Z"
						fill="#191919"
					/>
					<path
						d="M12.9823 8.43095H11.7556C11.5531 8.43095 11.3955 8.27339 11.3955 8.07082C11.3955 7.86825 11.5531 7.71069 11.7556 7.71069H12.9823C13.1849 7.71069 13.3425 7.86825 13.3425 8.07082C13.3425 8.27339 13.1849 8.43095 12.9823 8.43095Z"
						fill="#191919"
					/>
					<path
						d="M15.897 17.3777C15.807 17.3777 15.7169 17.344 15.6494 17.2765C15.5706 17.1977 15.5256 17.0851 15.5369 16.9726L15.7394 14.9019C15.7394 14.8231 15.7845 14.7556 15.8295 14.688L20.68 9.31987C21.1189 8.82469 21.9179 8.82469 22.3681 9.31987L22.8407 9.83755C23.2796 10.3327 23.2796 11.098 22.8407 11.5932L17.9902 16.9613C17.934 17.0289 17.8552 17.0626 17.7764 17.0739L15.9533 17.3552C15.9533 17.3552 15.9195 17.3552 15.897 17.3552V17.3777ZM16.4597 15.1044L16.3134 16.59L17.5401 16.3986L22.3005 11.1205C22.4919 10.9067 22.4919 10.5466 22.3005 10.344L21.8279 9.8263C21.6591 9.63498 21.389 9.64624 21.2201 9.8263L16.4484 15.1157L16.4597 15.1044Z"
						fill="#191919"
					/>
					<path
						d="M18.238 16.5338C18.1367 16.5338 18.0354 16.4888 17.9679 16.41L16.3473 14.6206C16.2123 14.4743 16.2235 14.238 16.3698 14.1029C16.5161 13.9679 16.7525 13.9791 16.8875 14.1254L18.5081 15.9148C18.6431 16.0611 18.6319 16.2975 18.4856 16.4325C18.4181 16.5 18.328 16.5225 18.238 16.5225V16.5338Z"
						fill="#191919"
					/>
					<path
						d="M21.9743 12.3922C21.873 12.3922 21.7717 12.3472 21.7042 12.2684L20.0836 10.479C19.9486 10.3327 19.9599 10.0964 20.1062 9.96133C20.2525 9.82628 20.4888 9.83754 20.6238 9.98384L22.2444 11.7732C22.3795 11.9195 22.3682 12.1559 22.2219 12.2909C22.1544 12.3584 22.0644 12.3809 21.9743 12.3809V12.3922Z"
						fill="#191919"
					/>
					<path
						d="M10.3601 8.95976H6.27492C6.07235 8.95976 5.91479 8.8022 5.91479 8.59963C5.91479 8.39706 6.07235 8.2395 6.27492 8.2395H10.3601C10.5627 8.2395 10.7203 8.39706 10.7203 8.59963C10.7203 8.8022 10.5627 8.95976 10.3601 8.95976Z"
						fill="#191919"
					/>
					<path
						d="M10.3601 10.2764H6.27492C6.07235 10.2764 5.91479 10.1189 5.91479 9.91628C5.91479 9.71371 6.07235 9.55615 6.27492 9.55615H10.3601C10.5627 9.55615 10.7203 9.71371 10.7203 9.91628C10.7203 10.1189 10.5627 10.2764 10.3601 10.2764Z"
						fill="#191919"
					/>
					<path
						d="M10.3601 11.5933H6.27492C6.07235 11.5933 5.91479 11.4357 5.91479 11.2332C5.91479 11.0306 6.07235 10.873 6.27492 10.873H10.3601C10.5627 10.873 10.7203 11.0306 10.7203 11.2332C10.7203 11.4357 10.5627 11.5933 10.3601 11.5933Z"
						fill="#191919"
					/>
					<path
						d="M10.3601 12.91H6.27492C6.07235 12.91 5.91479 12.7524 5.91479 12.5498C5.91479 12.3473 6.07235 12.1897 6.27492 12.1897H10.3601C10.5627 12.1897 10.7203 12.3473 10.7203 12.5498C10.7203 12.7524 10.5627 12.91 10.3601 12.91Z"
						fill="#191919"
					/>
					<path
						d="M10.3601 14.2266H6.27492C6.07235 14.2266 5.91479 14.069 5.91479 13.8665C5.91479 13.6639 6.07235 13.5063 6.27492 13.5063H10.3601C10.5627 13.5063 10.7203 13.6639 10.7203 13.8665C10.7203 14.069 10.5627 14.2266 10.3601 14.2266Z"
						fill="#191919"
					/>
					<path
						d="M8.69454 15.5435H6.27492C6.07235 15.5435 5.91479 15.3859 5.91479 15.1834C5.91479 14.9808 6.07235 14.8232 6.27492 14.8232H8.69454C8.89711 14.8232 9.05467 14.9808 9.05467 15.1834C9.05467 15.3859 8.89711 15.5435 8.69454 15.5435Z"
						fill="#191919"
					/>
				</g>
				<defs>
					<clipPath id="clip0_4564_301561">
						<rect width={20.1785} height={14} fill="white" transform="translate(3 6)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgEducationUnique24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgEducationUnique24;
